// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RPFZ","left":"styles_left__1Viwr"};